import { render, staticRenderFns } from "./EventAdminFeatures.vue?vue&type=template&id=05ab6618"
import script from "./EventAdminFeatures.js?vue&type=script&lang=js&external"
export * from "./EventAdminFeatures.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports